import { configureStore } from "@reduxjs/toolkit";

import accountReducer from "./redux/AccountRedux";
import addressListReducer from "./redux/AddressRedux";
import cartReducer from "./redux/CartRedux";
import userMeasurementsReducer from "./redux/MeasurementsRedux";
import ordersListReducer from "./redux/OrdersListRedux";
import productReviewsReducer from "./redux/ProductReviewsRedux";
import productReducer from "./redux/ProductsListRedux";
import overlayAccountViewReducer from "./redux/UIOverlayAccountViewRedux";
import overlayAddressViewReducer from "./redux/UIOverlayAddressViewRedux";
import overlayFlowVersionViewReducer from "./redux/UIOverlayFlowVersionRedux";
import overlayMeasurementSelectionViewReducer from "./redux/UIOverlayMeasurementSelectionViewRedux";
import overlayMeasurementMethodSelectionViewReducer from "./redux/UIOverlayMeasurementMethodSelectionViewRedux";
import overlayNavbarReducer from "./redux/UIOverlayNavbarRedux";
import overlayOngkirReducer from "./redux/UIOverlayOngkirRedux";
import overlayPopupReducer from "./redux/UIOverlayPopupRedux";
import overlaySizeChartReducer from "./redux/UIOverlaySizeChartRedux";
import categoryReviewReducer from "./redux/CategoryReviewRedux";
import mailingPreferenceReducer from "./redux/MailingPreferenceRedux";
import productAnalyticsLogReducer from "./redux/ProductAnalyticsRedux";
import livestreamStateReducer from "./redux/LivestreamRedux";
import storeProfileReducer from "./redux/StoreProfileRedux";
import microphoneReducer from './redux/MicrophoneRedux';
import orderStateReducer from './redux/OrderRedux';

const store = configureStore({
    reducer: {
        account: accountReducer,
        cart: cartReducer,
        productsList: productReducer,
        productReviews: productReviewsReducer,
        userMeasurementsList: userMeasurementsReducer,
        orderState: orderStateReducer,
        ordersList: ordersListReducer,
        addressList: addressListReducer,
        categoryReviewList: categoryReviewReducer,
        mailingPreference: mailingPreferenceReducer,
        productAnalyticsLog: productAnalyticsLogReducer,
        livestreamState: livestreamStateReducer,
        microphoneState: microphoneReducer,
        storeProfile: storeProfileReducer,
        // UI States
        overlayAccountView: overlayAccountViewReducer,
        overlayAddressView: overlayAddressViewReducer,
        overlayMeasurementMethodSelectionView: overlayMeasurementMethodSelectionViewReducer,
        overlayMeasurementSelectionView: overlayMeasurementSelectionViewReducer,
        overlayFlowVersionView: overlayFlowVersionViewReducer,
        overlayPopup: overlayPopupReducer,
        overlayNavbar: overlayNavbarReducer,
        overlaySizeChart: overlaySizeChartReducer,
        overlayOngkir: overlayOngkirReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
